export default "__VITE_ASSET__BzjICKG5__"